import { useState } from 'react';
import styled from 'styled-components';
import { Connector, useConnectors } from 'utils/connectors';
import { Button, Card, Group, Text, Image, Pagination } from '@mantine/core';
import { useNavigate } from 'react-router';
const StyledList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: 1fr;
  gap: 15px 15px;
`;

const StyledConnectorPaginationWrapper = styled.div`
  margin-top: 15px;
`;

const SHOPIFY_LOGO = {
  alt: '',
  src: '/shopify-logo.jpeg',
};

const FABRIC_LOGO = {
  alt: '',
  src: '/fabric-logo.webp',
};

const BIG_COMMERCE_LOGO = {
  alt: '',
  src: '/bigcommerce-logo.jpeg',
};

const getConnectorLogo = connector => {
  return connector.name === 'shopify'
    ? SHOPIFY_LOGO
    : connector.name === 'bigcommerence' || connector.name === 'bigcommerce'
    ? BIG_COMMERCE_LOGO
    : FABRIC_LOGO;
};

export const ConnectorList = () => {
  const { data, loading, error } = useConnectors();
  const navigate = useNavigate();
  const connectors = data?.Connectors;

  const [pageNumber, setPageNumber] = useState(1);
  const connectorPerPage = 12;

  const displayConnector = connectors?.edges?.length
    ? connectors.edges
        .slice((pageNumber - 1) * connectorPerPage, pageNumber * connectorPerPage)
        .map(({ node: connector }: { node: Connector }) => {
          if (!connector) return;
          const logo = getConnectorLogo(connector);

          return (
            <Card shadow="sm" p="lg">
              <Group position="apart" style={{ marginBottom: 5 }}>
                <Group style={{ alignItems: 'center', gap: '8px' }}>
                  <Image radius="md" width={24} height={24} {...logo} />
                  <Text style={{ textTransform: 'capitalize' }} weight={500}>
                    {connector.name}
                  </Text>
                </Group>
              </Group>

              <Text size="sm">{connector.description}</Text>

              <Button
                size="xs"
                color="dark"
                fullWidth
                onClick={() => navigate(`/connector/edit/${connector.id}`)}
                style={{ marginTop: 14 }}
              >
                Modify Connector
              </Button>
            </Card>
          );
        })
    : null;

  const pageCount = Math.ceil(connectors?.edges?.length / connectorPerPage);

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };

  return (
    <>
      <StyledList>
        {loading && <Text>Loading...</Text>}
        {error && !connectors && <Text>Failed to load connectors.</Text>}
        {displayConnector}
      </StyledList>
      <StyledConnectorPaginationWrapper>
        <Pagination
          page={pageNumber}
          total={pageCount}
          position={'center'}
          onChange={handlePageChange}
          radius={'xs'}
        />
      </StyledConnectorPaginationWrapper>
    </>
  );
};
